import { createTheme } from "@mui/material";

import { themeConfig } from "@constants/theme.config";

/**
 * E-Invoicing App Theme
 * Extended from the sage-network shared themeConfig
 * Add app-specific overrides here if needed
 */
export const theme = createTheme(themeConfig);
